export enum PmsType {
  OPERA = 'opera',
  STAYNTOUCH = 'stayntouch',
  INFOR = 'infor',
  MEWS = 'mews',
}

export const isPmsType = (value: unknown): value is PmsType => Object.values<unknown>(PmsType).includes(value);
